import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Body from '../partials/Body';

import styles from '../../../styles/blocks/scene.module.scss';

const propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    body: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    subtitle: null,
    body: null,
    className: null,
};

const SceneBlock = ({ title, subtitle, body, className }) => {
    return body || title || subtitle ? (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {title ? <p className={styles.title}>{title}</p> : null}
            {subtitle ? <Body className={styles.body} body={subtitle} /> : null}
            {body ? <Body className={styles.body} body={body} /> : null}
        </div>
    ) : null;
};

SceneBlock.propTypes = propTypes;
SceneBlock.defaultProps = defaultProps;

export default SceneBlock;
